import {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
} from 'react'
import { Tenant } from '../../../../models/Tenant'
import { tenants } from './tenants'
import { platforms } from './platforms'

type TenantContextProps = {
  /**
   * The current tenant
   */
  tenant: Tenant

  /**
   * All the platforms configured for the current tenant
   */
  platforms: Tenant['platforms']

  /**
   * All the plaform configurable
   */
  allPlatforms: typeof platforms
}

const TenantContext = createContext<TenantContextProps | undefined>(undefined)

const useTenant = (): TenantContextProps => {
  const value = useContext(TenantContext)
  if (!value) {
    throw new Error('useTenant() must be wrapped inside a <Tenant />')
  }
  return value
}

const TenantContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const tenant = useCallback(() => {
    const envName = import.meta.env.VITE_TENANT_NAME
    return tenants.find((tenant) => envName === tenant.envName) ?? tenants[0]
  }, [tenants])

  return (
    <TenantContext.Provider
      value={{
        tenant: tenant(),
        platforms: tenant().platforms,
        allPlatforms: platforms,
      }}
    >
      {children}
    </TenantContext.Provider>
  )
}

type TenantContextProviderType = typeof TenantContextProvider

export { TenantContextProvider, useTenant }
export type { TenantContextProviderType, TenantContextProps }
